import { grayPaletteDark } from '../../../themes/dark-colors';

export const pageDarkTheme = {
  backgroundColor: grayPaletteDark[100],
};
